// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"224":"806db0883bc12a46","326":"84d3acdf60c79641","819":"687501cae1793615"}[chunkId] + ".css";
};